import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomFieldTileComponent } from './custom-field-tile.component';
import { PipesModule } from '../../../core/pipes/pipes.module';
import { AutonumericModule } from '../../directives/autonumeric/autonumeric.module';
import { FocusModule } from '../../directives/focus/focus.module';
import { ImagesFallbackModule } from '../../directives/images-fallback/images-fallback.module';
import { OnRenderedModule } from '../../directives/on-rendered/on-rendered.module';
import { SwitchCasesModule } from '../../directives/switch-cases/switch-cases.module';
import { TooltipsModule } from '../../features/tooltip/tooltips.module';
import { IconModule } from '../icon/icon-module';

@NgModule({
  declarations: [CustomFieldTileComponent],
  imports: [
    CommonModule,
    TooltipsModule,
    AutonumericModule,
    FocusModule,
    ImagesFallbackModule,
    OnRenderedModule,
    SwitchCasesModule,
    PipesModule,
    IconModule,
  ],
  exports: [CustomFieldTileComponent],
})
export class CustomFieldTileModule {}
